import _ from 'lodash';

function CRClaimExtension(claim) {
    if (claim && claim.lobs && claim.lobs.crime) {
        _.extend(this, claim.lobs.crime);
    }
}

export default CRClaimExtension;
